import { Grid2, Paper } from '@mui/material';
import { FC } from 'react';
import { Button } from '../../../Components/Form/Button/button.scomponent';
import { Input } from '../../../Components/Form/Input/input.component';
import { Loader } from '../../../Components/Loader';
import { BaseContentPage } from '../../../Components/Templates/BaseContentPage/base-content-page.componen';
import { BaseScreen } from '../../../Components/Templates/BaseScreen/basescreen.component';
import { CreateSellersUseCase } from '../../../Usecase/Sellers/create-sellers-usecase';
import { useCreateSellers } from './sellers-create.hook';
import { UpdateSellersUseCase } from '../../../Usecase/Sellers/update-sellers-usecase';
import { ShowSellersUseCase } from '../../../Usecase/Sellers/show-sellers-usecase';
import { Can } from '../../../Components/Can';

interface ISellersFormProps {
    createSellersUseCase: CreateSellersUseCase,
    updateSellersUseCase: UpdateSellersUseCase,
    showSellersUseCase: ShowSellersUseCase
}

const SellersForm : FC<ISellersFormProps> = ({ createSellersUseCase, updateSellersUseCase, showSellersUseCase }) => {
    const { handleAction, loading, errors, register, handleSubmit } = useCreateSellers({
      createSellersUseCase,
      updateSellersUseCase,
      showSellersUseCase
    })

    return (
      <Can permissions={['menu:sellers:manage']}>  
        <BaseScreen>
            <Paper sx={{ borderRadius: 2, overflow: 'hidden', width: '100%' }}>
                <BaseContentPage 
                    title='Vendedores'
                    subtitle='Cadastro de vendedor'
                    breadcrumb={[{ title: 'Vendedores', link: "/sellers-list"}, { title: 'Novo Vendedor'}]}
                    minHeight="auto"
                >
                {loading && <Loader />}

                <Grid2
                  container
                  spacing={2}
                  sx={{ mt: 1, maxWidth: 720 }}
                  component="form"
                  onSubmit={handleSubmit(handleAction)}
                >
                  <Grid2 size={{ xs: 12, md: 6 }}>
                    <Input
                        label="Nome"
                        placeholder="Preencha o nome"
                        error={!!errors.name}
                        helperText={errors.name?.message}
                        {...register('name')}
                    />
                  </Grid2>

                  <Grid2 size={{ xs: 12, md: 6 }}>
                    <Input
                      label="E-mail"
                      placeholder="Preencha o e-mail"
                      error={!!errors.email}
                      helperText={errors.email?.message}
                      {...register('email')}
                    />
                  </Grid2>

                  <Grid2 size={12}>
                    <Button
                      type="submit"
                      sx={{ mt: 1, width: { xs: '100%', sm: '200px' } }}
                      isLoading={loading}
                    >
                      SALVAR
                    </Button>
                  </Grid2>
                </Grid2>
              </BaseContentPage>
            </Paper>
        </BaseScreen>
        </Can>
    )
}

export { SellersForm };
